$(document).ready(function() {
  var elem = document.querySelector(".seccion-terraza-detalle");
  if (elem == null) {
    return;
  }

  let fechasPreciosEspecial = []
  for(let i in fechasEspeciales){
    let item = fechasEspeciales[i]
    if(item.is_bloqueado){
      fechasNoDisponibles.push(item)
    }
    if(item.precio != null || item.precio_hora_extra != null){
      fechasPreciosEspecial.push(item)
    }
  }

  let owlCarruselImagenes;

  let vueAppDetalle = new Vue({
    el: elem,
    data: {
      //tiposEventos
      tiposEventosListado: [],
      tipoEvento: null,

      imagenes: [],
      imagenesExtras: [],
      terraza: terrazaJson,
      precios: terrazaJson.precios,
      precio: null,
      preciosDisponibles: [],

      diasSemanaHabilitados: [],
      personasListado: [],
      personas: null,

      horaInicio: null,
      horasDeInicio: [],
      horaFin: null,
      horasDeFin: [],
      fecha: null,
      langFecha: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: true,
      },
      disabledDates: function _default(date) {
        const hoy = new Date();
        const hoyDespues6Meses = new Date(hoy);
        hoyDespues6Meses.setMonth(hoy.getMonth() + 6);

        if(date < hoy || date > hoyDespues6Meses){
          return true
        }

        let dia = date.getDay();
        if(dia == 0){
          dia = 7
        }
        if(!vueAppDetalle.diasSemanaHabilitados.includes(dia)){
          return true
        }

        let fechaFormato = dayjs(date).format("YYYY-MM-DD")
        let fechasBloqueo = fechasNoDisponibles.filter(item => {
          return item.fecha == fechaFormato
        })

        if(fechasBloqueo.length > 0){
          if(fechasBloqueo.is_bloqueado){
            return true
          }
          let precios = vueAppDetalle.precios.filter(item => item.dia_semana == dia)
          return fechasBloqueo.length >= precios.length;
        }

        return date < new Date();
      },
    },
    computed: {
      url: function (){
        let base = "/checkout/agregar-servicios/"
        if(this.terraza.servicios.length == 0){
          base = "/checkout/finalizar/"
        }
        return base + this.terraza.slug + "_" + this.terraza.id;
      },
      fechaFormato: function (){
        if(this.fecha == null){
          return null;
        }
        return dayjs(this.fecha).format('YYYY-MM-DD')
      },
      totalTerraza: function (){
        let total = this.terraza.precio
        if(this.precio != null){
          total = this.precio.precio
        }
        if(this.personas != null){
          total += this.personas.precio_extra ?? 0
        }
        if(this.horaFin != null){
          total += this.horaFin.precio_extra
        }
        return total
      },
    },
    mounted() {
      CheckMapaImagenes()
      if(terrazaJson.imagenes.length > 1){
        let splice = 2
        if(terrazaJson.imagenes.length > 3){
          splice = 4
        }
        this.imagenes = terrazaJson.imagenes.slice(0, splice);
        this.imagenesExtras = terrazaJson.imagenes.slice(splice);
      }
      else{
        this.imagenes = [];
        this.imagenesExtras = terrazaJson.imagenes;
      }

      for(let index in this.precios){
        if(!this.diasSemanaHabilitados.includes(this.precios[index].dia_semana)){
          this.diasSemanaHabilitados.push(this.precios[index].dia_semana)
        }
      }
      let minPersonas = terrazaJson.min_personas;
      if(minPersonas == 1){
        this.personasListado.push({
          code: minPersonas,
          label: minPersonas + " persona",
          precio_extra: 0
        })
        minPersonas = 10;
      }
      for(let i = minPersonas; i <= terrazaJson.max_personas; i+=10){
        this.personasListado.push({
          code: i,
          label: i + " personas",
          precio_extra: 0
        })
      }
      this.personas = this.personasListado[0]

      for(let i in tiposEventosJson){
        this.tiposEventosListado.push({
          code: tiposEventosJson[i].id,
          label: tiposEventosJson[i].nombre,
          icono: tiposEventosJson[i].imagen_thumb,
        })
      }

      if(fechaTexto != "" ||
        horaInicioTexto != "" || personasTexto != ""){
        $('html, body').animate({
          scrollTop: $(".avanzar-terraza").offset().top - $("header").innerHeight()
        }, 0);
      }
      if(fechaTexto != ""){
        this.fecha = dayjs(fechaTexto).toDate()
        this.actualizarDia(this.fecha)
      }
      if(horaInicioTexto != ""){
        this.horaInicio = {code: horaInicioTexto, label: horaInicioTexto.substring(0, horaInicioTexto.length -3)}
        if(horaFinTexto != null){
          this.actualizarHoraInicio(this.horaInicio, horaFinTexto)
        }
      }
      if(personasTexto != ""){
        this.personas = {code: parseInt(personasTexto), label: parseInt(personasTexto) + " personas"}
      }

      if(tipoEventoTexto != ""){
        this.tipoEvento = this.tiposEventosListado.find(item => item.code == tipoEventoTexto)
      }

      Fancybox.bind('[data-fancybox="Terraza"]', {

      })
      Fancybox.bind('[data-fancybox="TerrazaTelefono"]', {

      })

      owlCarruselImagenes = $('.owl-carousel-telefono').owlCarousel({
        loop: false,
        margin: 0,
        dots: false,
        smartSpeed: 1500,
        nav: false,
        // dots: true,
        autoplay: true,
        items: 1,
        // navText : ['<div class="ms-nav-prev"></div>','<div class="ms-nav-next"></div>'],
      });

      var totalItems = $('.owl-item:not(.cloned)').length;

      $('#totalImages').text(totalItems);

      owlCarruselImagenes.on('changed.owl.carousel', function(event) {
        var currentIndex = event.item.index - event.relatedTarget._clones.length / 2;
        var currentItem = (currentIndex % totalItems + totalItems) % totalItems + 1; // Ajuste para índices negativos
        $('#currentImage').text(currentItem);
      })

      $('[data-toggle="tooltip"]').tooltip();

    },
    methods: {
      actualizarDia(date){
        let fechaFormato = null
        if(date == null){
          this.preciosDisponibles = []
        }
        else{
          let dia = date.getDay();
          if(dia == 0){
            dia = 7
          }
          fechaFormato = dayjs(date).format("YYYY-MM-DD")
          let fechasBloqueo = fechasNoDisponibles.filter(item => {
            return item.fecha == fechaFormato
          })

          this.preciosDisponibles = this.precios.filter(item => {
            let existe = fechasBloqueo.find(item2 => item2.terraza_precio_id == item.id )
            return item.dia_semana == dia && existe == null
          })
        }

        if(this.preciosDisponibles.length > 0){
          this.precio = Object.assign({}, this.preciosDisponibles[0])

          let precioEspecial = fechasPreciosEspecial.find(item => item.fecha == fechaFormato)
          if(precioEspecial != null){
            if(precioEspecial.precio != null){
              this.precio.precio = precioEspecial.precio
            }
            if(precioEspecial.precio_hora_extra != null){
              this.precio.precio_hora_extra = precioEspecial.precio_hora_extra
            }
          }
        }
        else{
          this.precio = null
        }
        this.horaInicio = null
        this.horasExtras = null
        // this.horasOpciones = []
        this.actualizarHoraInicioDisponibles()
      },
      actualizarHoraInicioDisponibles(){
        this.horasDeInicio = []
        this.horasDeFin = []
        this.horaFin = null

        if(this.preciosDisponibles.length > 0) {
          for(let i in this.preciosDisponibles){
            let precioListado = this.preciosDisponibles[i]

            let horaInicio = dayjs(this.fechaFormato + " " + precioListado.hora_inicio, "YYYY-MM-DD HH:mm");
            let maxHoraInicio = dayjs(this.fechaFormato + " " + precioListado.hora_fin, "YYYY-MM-DD HH:mm");
            maxHoraInicio = maxHoraInicio.add(this.terraza.min_horas * -1, 'hours');

            if(horaInicio.isAfter(maxHoraInicio)){
              maxHoraInicio = maxHoraInicio.add(1, "days")
            }

            do{
              this.horasDeInicio.push({
                code: horaInicio.format("HH:mm:ss"),
                label: horaInicio.format("HH:mm")
              })
              horaInicio = horaInicio.add(30, "minutes")
            }
            while (maxHoraInicio.isAfter(horaInicio))

            this.horasDeInicio.push({
              code: horaInicio.format("HH:mm:ss"),
              label: horaInicio.format("HH:mm")
            })
          }
        }
        this.actualizarPrecioPersonas()
      },

      actualizarHoraInicio(hora, horaFinDefecto = null){
        this.horasDeFin = []
        if(hora == null){
          this.horaFin = null
          return
        }
        let fechaFormato = this.fechaFormato

        let precioEspecial = fechasPreciosEspecial.find(item => item.fecha == fechaFormato)

        let fecha = dayjs(this.fechaFormato + " " +hora.code, "YYYY-MM-DD HH:mm:ss").toDate();
        let precioEncontrado = null
        for(let index in this.preciosDisponibles){
          let precio = Object.assign({}, this.preciosDisponibles[index])

          if(precioEspecial != null){
            if(precioEspecial.precio != null){
              precio.precio = precioEspecial.precio
            }
            if(precioEspecial.precio_hora_extra != null){
              precio.precio_hora_extra = precioEspecial.precio_hora_extra
            }
          }

          let horaFinArr = precio.hora_fin.split(":")
          horaFinArr[0] = parseInt(horaFinArr[0]) - this.terraza.min_horas

          let fechaInicio = dayjs(this.fechaFormato + " " + precio.hora_inicio, "YYYY-MM-DD HH:mm")
          let fechaFin = dayjs(this.fechaFormato + " " + precio.hora_fin, "YYYY-MM-DD HH:mm")
          fechaFin = fechaFin.add(this.terraza.min_horas * -1, 'hours');
          if (fechaInicio.isAfter(fechaFin)) {
            fechaFin = fechaFin.add(1, 'days');
          }
          fechaInicio = fechaInicio.toDate()
          fechaFin = fechaFin.toDate()

          let horaEncontrada = fecha.valueOf() >= fechaInicio.valueOf()
            && fecha.valueOf() <= fechaFin.valueOf()
          if(horaEncontrada){
            precioEncontrado = precio
            break
          }
        }

        this.precio = precioEncontrado

        let horaInicio = dayjs(this.fechaFormato + " " +hora.code, "YYYY-MM-DD HH:mm:ss")
        let horaFin = dayjs(this.fechaFormato + " " +precioEncontrado.hora_fin, "YYYY-MM-DD HH:mm:ss");
        horaInicio = horaInicio.add(this.terraza.min_horas, 'hours');

        if(horaInicio.isAfter(horaFin)){
          horaFin = horaFin.add(1, "days")
        }

        let horaExtra = 0
        let precioHoraExtra = 0
        if(precioEncontrado.precio_hora_extra > 0){
          precioHoraExtra = precioEncontrado.precio_hora_extra
        }
        let index = 1
        while (horaFin.isAfter(horaInicio)) {
          this.horasDeFin.push({
            code: horaInicio.format("HH:mm:ss"),
            label: horaInicio.format("HH:mm"),
            hora_extra: horaExtra,
            precio_extra: horaExtra * precioHoraExtra
          })
          horaInicio = horaInicio.add(30, "minutes")
          index += 1
          if(index % 2 == 0){
            horaExtra+=1
          }
        }

        this.horasDeFin.push({
          code: horaInicio.format("HH:mm:ss"),
          label: horaInicio.format("HH:mm"),
          hora_extra: horaExtra,
          precio_extra: horaExtra * precioHoraExtra
        })

        if(this.horaFin != null){
          let horaCode = this.horaFin.code
          let findIndex = this.horasDeFin.findIndex(item => item.code == horaCode)
          if(findIndex > -1){
            this.horaFin = this.horasDeFin[findIndex]
          }
          else{
            this.horaFin = null
          }
        }

        if(horaFinDefecto != null){
          let findIndex = this.horasDeFin.findIndex(item => item.code == horaFinDefecto)
          if(findIndex > -1){
            this.horaFin = this.horasDeFin[findIndex]
          }
        }
        this.actualizarPrecioPersonas()
      },
      actualizarPrecioPersonas(){
        let preciosPersonas = []

        if(this.precio.extras != null
          && this.precio.extras.personas != null
          && this.precio.extras.personas.length > 0) {
          preciosPersonas = this.precio.extras.personas
        }
        this.personasListado = this.personasListado.map(item => {
          item.precio_extra = 0
          if(preciosPersonas.length > 0){
            let precios = preciosPersonas.filter(itemPrecio => {
              return parseInt(itemPrecio.min) <= parseInt(item.code) &&
                parseInt(itemPrecio.max) >= parseInt(item.code)
            })
            if(precios.length > 0){
              item.precio_extra = precios.reduce((acc, obj) => (parseFloat(obj.precio) > acc ? parseFloat(obj.precio) : acc), 0);
            }
          }
          return item
        });
      },
      avanzarCheckout(e){
        if(this.tipoEvento == null){
          swal({
            icon: "info",
            title: "Selecciona un tipo de evento",
            button: {
              text: "Aceptar",
              closeModal: true,
            },
          })
          return
        }
        if(this.fecha == null){
          swal({
            icon: "info",
            title: "Selecciona una fecha",
            button: {
              text: "Aceptar",
              closeModal: true,
            },
          })
          return
        }
        if(this.horaInicio == null){
          swal({
            icon: "info",
            title: "Selecciona una hora de inicio",
            button: {
              text: "Aceptar",
              closeModal: true,
            },
          })
          return
        }
        if(this.horaFin == null){
          swal({
            icon: "info",
            title: "Selecciona una hora de fin",
            button: {
              text: "Aceptar",
              closeModal: true,
            },
          })
          return
        }
        let params = {
          personas: this.personas.code,
          fecha: this.fechaFormato,
          hora_inicio: this.horaInicio.code,
          hora_fin: this.horaFin.code,
          tipo_evento_id: this.tipoEvento.code,
        }

        let url = this.url + "?" + new URLSearchParams(params).toString()
        if(e.submitter.dataset.auth == '0'){
          $("#formLogin")[0].dataset.url = url;
          $("#modalLogIn").modal("show")
        }
        else{
          location.href = url
        }
      }
    }
  });

});
